// JavaScript on purpose, typed by loadGltfScene.d.ts. GLTFLoader's typings
// import KTX2Loader, which imports "three/webgpu"; its renderers/common/
// Backend.d.ts augments Object3D. As soon as a TypeScript module that imports
// GLTFLoader is part of this package's import graph (imported from ThreeTools
// or any other module, statically or dynamically), `tsc --noEmit
// --incremental false -p packages/emerge/tsconfig.json` reports 11 errors
// like "TS2345: Argument of type 'Object3D<…>' is not assignable to parameter
// of type 'Object3D<…>'. The types returned by 'applyQuaternion(...)' are
// incompatible" in meshEditorModel, MeshEditorView, ProductViewerPostProcessing,
// SupplyPartRenderer and ThreeTools, both types from the one
// @types/three@0.179.0. A TypeScript file that imports
// GLTFLoader but is imported by nobody checks clean, and so does this
// JavaScript file, although it brings the same typings into the program.
import { formatUnknownError } from "@project/shared";
import { LoadingManager } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { restrictToAssetOrigin } from "./assetUrlGuard";

/**
 * Loads the scene of a GLB or a self-contained GLTF.
 *
 * @param {string} url
 * @returns {Promise<import("three").Group>}
 */
export function loadGltfScene(url) {
  const manager = new LoadingManager();
  restrictToAssetOrigin(manager, url);
  const loader = new GLTFLoader(manager);
  return new Promise((resolve, reject) => {
    loader.load(
      url,
      (gltf) => resolve(gltf.scene),
      undefined,
      (err) =>
        reject(err instanceof Error ? err : new Error(formatUnknownError(err))),
    );
  });
}
